<template>
	<div class="warning-item" :class="colorClass">
		<div class="warning-item-icon" :class="colorClass">
			<sym-icon :name="icon"/>
		</div>
		<div class="warning-item-message">
			<span v-if="isStringWarn">{{ warn }}</span>
			<span v-else>
				<span>{{ warn.message }}</span>
				<span v-if="warn.actions" v-html="warn.actions"></span>
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {WarningAction} from "@t/note/Warning.ts";
import {DEFAULT_EVENT_COLOR} from "@t/fd/editor/EventColor.ts";

const props = defineProps<{
	warn: WarningAction | string
}>();

const icon = computed<string>(()=> props.warn.icon || "warning-18-bold");
const isStringWarn = computed<boolean>(() => typeof props.warn === "string");
const colorClass = computed<string>(()=> { return "color-"+(props.warn.color?props.warn.color:DEFAULT_EVENT_COLOR); });
</script>

<style>

</style>